<div class="container-fluid" style="padding: 2rem;">
    <div class="header-section">
        <h2>Debugging</h2>
        <p>Test and debug application features</p>
    </div>

    <div class="debugging-grid">
        <!-- Error Tracking Card -->
        <mat-card class="content-card debug-card">
            <mat-card-header>
                <mat-card-title>Sentry Error Tracking</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p class="card-description">
                    Test Sentry error tracking and monitoring by triggering a test error.
                </p>
                <div class="button-group">
                    <button
                        mat-raised-button
                        color="primary"
                        (click)="throwTestError(true)">
                        With Report Modal
                    </button>
                    <button
                        mat-raised-button
                        color="primary"
                        (click)="throwTestError(false)">
                        Without Report Modal
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>